import * as React from 'react';
import * as S from './styles';
import { ITopTextProps } from './types';
import { TCButton } from 'components/TCButton';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import EditIcon from 'common/icons/editIcon';
import { RootState } from 'store/types';
import { cloneDeep } from 'lodash';
import { saveWidgetsConfig } from '../../state/utils';

const TopTextInput: React.FC<ITopTextProps> = (props) => {

    const dispatch = useDispatch();
    const {
        widgets,
    } = useSelector((rootState: RootState) => {
        return {
            widgets: rootState.reviews.widgets,
        }
    }, shallowEqual);
    const textValue = props.widgetsConfig[props.widgetType].title??'';

    const [editing, setEditing] = React.useState(false);
    const [inputValue, setInputValue] = React.useState('');
    const [saving, setSaving] = React.useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    }

    const handleSave = async () => {
        if (widgets) {
            setSaving(true);
            try {
                let newWidgets = cloneDeep(widgets);
                newWidgets[`${props.selectedTab}Config`][props.widgetType].title = inputValue;
                await saveWidgetsConfig(dispatch, newWidgets);
                setSaving(false);
                handleCancel();
            } catch(e) {
                setSaving(false);
                console.error(e);
            }
        }
    }

    const handleCancel = () => {
        setEditing(false);
        setInputValue("");
    }

    const handleEdit = () => {
        setEditing(true);
        setInputValue(textValue);
    }

    return (
        <S.Root
            style={props.style}
        >
            {
                editing ?
                    <S.Input
                        style={props.inputStyle}
                        onChange={handleChange}
                        value={inputValue}
                    />
                    :
                    React.createElement(
                        props.textTag ?? "h2",
                        { style: props.textStyle }, 
                        textValue
                    )
            }
            {
                editing ?
                    <S.ActionsContainer>
                        <S.ButtonContainer>
                            <TCButton
                                type={TC_BUTTON_TYPE.LISMA}
                                onClick={handleSave}
                                disabled={saving || !inputValue.length}
                            >
                                {saving ? `Saving...` : `Save`}
                            </TCButton>
                        </S.ButtonContainer>
                        <S.ButtonContainer>
                            <TCButton
                                type={TC_BUTTON_TYPE.LISMA}
                                onClick={handleCancel}
                                disabled={saving}
                            >
                                Cancel
                            </TCButton>
                        </S.ButtonContainer>
                    </S.ActionsContainer>
                    :
                    <S.EditIconContainer
                        onClick={handleEdit}
                    >
                        <EditIcon />
                    </S.EditIconContainer>
            }
        </S.Root>
    );
}

export default TopTextInput;
